import { useAppData } from '@src/hooks/api/use-app-data';
import { usePageTrackers } from '@src/hooks/tracker/use-page-trackers';
import { useMutateOnRouting } from '@src/hooks/use-mutate-on-routing';
import { useGlobalStore } from '@src/hooks/use-global-store';
import { jsBridge } from '@src/utils/js-bridge';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { ComponentType, useEffect, useState } from 'react';
import ErrorHandler from './error/ErrorHandler';
import PopupVideo from './popup-video/PopupVideo';
import { removeCIDUrl } from '@src/utils/util';
import { Toaster } from 'react-hot-toast';
// import LoadingST from './loading-ST/LoadingST';
// import LoadingST from './loading-ST/LoadingST';
// import PopupModal from './popup-modal/PopupModal';

type Props = {
    page: ComponentType<unknown>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pageProps: any;
};
export const AppRoot = observer((props: Props) => {
    // const hasFetched = useRef(false);
    const router = useRouter();
    const globalStore = useGlobalStore();

    const videoPopupStore = globalStore.videoPopupStore;
    const isPreviewPage = /\/share\//.test(router.asPath);

    const [enabledPopupVideo, setEnabledPopupVideo] = useState(false);

    useEffect(() => {
        // console.log('首页----下发');
        globalStore.settingStore?.loadSettings();
    }, [globalStore]);

    const base = useAppData();
    useEffect(() => {
        globalStore.baseStore.setDataResponse(base);
        globalStore.baseStore.locale = router.locale || '';
    }, [base, globalStore, router.locale]);

    usePageTrackers(props.pageProps);
    useMutateOnRouting();

    // const getLocalStorageData = useCallback(async () => {
    //     if (!hasFetched.current) {
    //         hasFetched.current = true;
    //         console.log('--------Router Calendar再次下發請求-----');
    //         await globalStore?.settingStore?.loadSettings();
    //     }
    // }, [globalStore]);

    useEffect(() => {
        jsBridge.onCalendarBtnClicked = () => {
            setTimeout(() => {
                globalStore?.settingStore?.loadSettings();
                // console.log('--------Router Calendar再次下發請求-----');
            }, 500);

            router.push(removeCIDUrl(`/calendar/${location.search}`));
        };
        return () => {
            jsBridge.onCalendarBtnClicked = undefined;
        };
    }, [globalStore?.settingStore, router]);

    useEffect(() => {
        const handleVideoPop = (event: MouseEvent) => {
            const hadleTarget = (e: HTMLElement | null | undefined, limit: number) => {
                const l = limit - 1;
                if (l === 0) {
                    return;
                }
                if (e?.classList.contains('video-pop')) {
                    const url = e.getAttribute('data-poster') as string;
                    const poster = e.getAttribute('data-image') as string;
                    videoPopupStore.updateUrlValue(url);
                    videoPopupStore.updatePosterValue(poster);
                    if (url) {
                        setEnabledPopupVideo(true);
                    }
                } else {
                    hadleTarget(e?.parentElement, l);
                }
            };
            const target = event.target as HTMLElement;
            hadleTarget(target, 5);
        };

        document.addEventListener('click', handleVideoPop, false);
        router.events.on('routeChangeStart', () => {
            setEnabledPopupVideo(false);
        });
        return () => {
            document.removeEventListener('click', handleVideoPop);
            router.events.off('routeChangeStart', () => {
                setEnabledPopupVideo(false);
            });
        };
    }, [router.events, videoPopupStore]);

    if (props.pageProps.errorPageType) {
        // console.log('appRoot-errorHandler============', props.pageProps);
        return <ErrorHandler {...props.pageProps}></ErrorHandler>;
    }

    if (
        (globalStore.baseStore?.isLoading || globalStore.settingStore?.isLoading) &&
        !isPreviewPage
    ) {
        // console.log('无数据页面');
        return <></>;
    }

    // console.log('---------AppRoot 页面-------');

    return (
        <>
            <props.page {...props.pageProps}></props.page>

            <Toaster />

            {enabledPopupVideo && (
                <PopupVideo
                    enabled={enabledPopupVideo}
                    videoURL={videoPopupStore.getVideoUrl}
                    videoPoster={videoPopupStore.getVideoPoster}
                    contentBlock={videoPopupStore.getContentBlockData}
                    onClose={() => {
                        setEnabledPopupVideo(false);
                        videoPopupStore.enabledPopupVideo = false;
                        videoPopupStore.updateUrlValue('');
                        videoPopupStore.updatePosterValue('');
                        videoPopupStore.updateContentBlockData();
                    }}
                />
            )}
        </>
    );
});
